import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import GreetingCard from "./GreetingCard";
import StatsCards from "./Statscards";
import DailyPerformanceCircle from "./DailyPerformanceChart";
import TechBadge from "./TechBadge";
import UserProfileCard from "./UserProfileCard";
import LevelTests from "./LevelTests";
import ProgressList from "./ProgressList";
import users from "../../redux/actions/users";
import { BiTestTube } from "react-icons/bi";

const Dashboard = () => {
  const currentUser = users.getCurrentUser();
   const navigate = useNavigate();

  const user = {
    name: currentUser
      ? `${currentUser.firstName} ${currentUser.lastName}`
      : "Utilisateur inconnu",
    role: currentUser
      ? currentUser.is_coach
        ? "Coach"
        : "Étudiant"
      : "Rôle inconnu",
    avatarUrl: "/avatar.png",
  };

  
  const [step, setStep] = useState(0); 

  useEffect(() => {
    setStep(1);
  }, []);

  const goToEvaluation = () => {
    setStep(0); 
    navigate("/evaluation");
  };

   const goToQuiz = () => {
    setStep(0);
    navigate("/quizz");
  };

  return (
    <div className="bg-white min-h-screen">
      <Navbar />

       {/* === MODAL === */}
      {step === 1 && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-[90%] max-w-md text-center relative border-2 border-orange-400">
           
            <div className="flex justify-center mb-4 text-orange-500">
              <BiTestTube  size={48} />
            </div>

           
            <h2 className="text-xl font-bold mb-6">
              Aimeriez-vous <br /> que l’on évalue votre niveau ?
            </h2>

            
            <div className="flex flex-col gap-4">
              <button
                onClick={() => setStep(2)}
                className="bg-teal-500 hover:bg-teal-400 w-30% text-white font-semibold py-2 rounded-full transition"
              >
                Oui
              </button>
              <button
                onClick={() => setStep(0)}
                className="bg-red-400 hover:bg-red-300 text-white font-semibold py-2 rounded-full transition"
              >
                Non
              </button>
            </div>
          </div>
        </div>
      )}
      {/* === FIN MODAL === */}

            {/* === DEUXIÈME MODAL === */}
      {step === 2 && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-[90%] max-w-md text-center relative border-2 border-orange-400">
          
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold mb-2">Option 1 :</h3>
                <button 
                  onClick={goToEvaluation}
                  className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full w-full"
                >
                  Pratique (20mn) →
                </button>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-2">Option 2 :</h3>
                <button 
                  onClick={goToQuiz}  
                className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full w-full">
                  Théorie (5mn) →
                </button>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-2">Option 3 :</h3>
                <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full w-full">
                  Complet (25mn) →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      <div className="d-flex">
        <div className="max-w-[1440px] mx-auto px-4 py-6 flex flex-col lg:flex-row gap-6">
          <main className="flex-1 space-y-6">
            <GreetingCard
              username={currentUser?.firstName || "Utilisateur"}
              percent={70}
              objectif="votre objectif"
              buttonText="On y retourne ?"
              illustration="/working-woman.png"
            />

            <div>
              <h2 className="text-xl font-semibold mt-4">Statistiques</h2>
              <StatsCards />
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-4">Tests de niveau</h2>
              <LevelTests />
            </div>

            <div className="border text-center py-5 bg-white rounded-xl shadow-sm">
              <h2 className="text-xl font-semibold mb-2">
                Les technologies les plus populaires
              </h2>
              <div className="flex gap-3 flex-wrap justify-center">
                <TechBadge techName="CSS" color="bg-blue-700" />
                <TechBadge techName="Bootstrap" color="bg-purple-500" />
                <TechBadge techName="Python" color="bg-green-600" />
              </div>
            </div>
          </main>
        </div>

        <aside className="w-full lg:w-[30%] space-y-4 bg-stone-300 px-5 py-4 hidden lg:block">
          <UserProfileCard
            name={user.name}
            role={user.role}
            avatarUrl={user.avatarUrl}
          />

          <DailyPerformanceCircle
            redValue={45}
            greenValue={80}
            dateLabel="Hier"
          />

          <div className="mt-5">
            <ProgressList />
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Dashboard;
